.i{align-items:center;}